(() => {
  const component = document.querySelector("[data-bb-gift-roulette]");
  if (!component || component.dataset.initialized === "true") return;
  component.dataset.initialized = "true";

  const rootPath = window.Shopify?.routes?.root || "/";
  const apiBase = String(component.dataset.apiBase || "/apps/blankabric-wishlist").replace(/\/+$/, "");
  const previewMode = component.dataset.previewMode === "true";
  const currency = component.dataset.currency || window.Shopify?.currency?.active || "EUR";
  const locale = document.documentElement.lang || window.Shopify?.locale || "fr";
  const defaultCheckoutUrl = component.dataset.checkoutUrl || "/checkout";
  const teaserDelay = Math.max(0, Number(component.dataset.teaserDelay || 7000));
  const params = new URLSearchParams(window.location.search);
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  const fetchWithTimeout = async (input, options = {}, timeoutMs = 8000) => {
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), timeoutMs);
    try {
      return await fetch(input, { ...options, signal: controller.signal });
    } finally {
      window.clearTimeout(timer);
    }
  };

  const wait = (delayMs) => new Promise((resolve) => window.setTimeout(resolve, delayMs));

  const parseJson = (element, fallback) => {
    try {
      return JSON.parse(element?.textContent || "");
    } catch (_error) {
      return fallback;
    }
  };

  const escapeHtml = (value) =>
    String(value || "").replace(/[&<>'"]/g, (character) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      "'": "&#39;",
      '"': "&quot;",
    })[character]);

  const formatLabel = (text, values) =>
    Object.entries(values || {}).reduce((result, [key, value]) => {
      const escapedKey = String(key).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      return result.replace(new RegExp(`\\{\\{\\s*${escapedKey}\\s*\\}\\}`, "g"), value);
    }, String(text || ""));

  const formatCurrency = (amountCents, currencyCode = currency || "EUR") => {
    const amount = Math.max(0, Number(amountCents || 0)) / 100;
    try {
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currencyCode,
        maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
      }).format(amount);
    } catch (_error) {
      return `${amount} ${currencyCode}`;
    }
  };

  const imageUrl = (prize) => {
    const image = prize?.image || prize?.image_url || prize?.featured_image || "";
    return typeof image === "string" ? image : String(image?.url || image?.src || "");
  };

  const normalizePrize = (prize, includeWeight = false) => {
    if (!prize || typeof prize !== "object") return null;
    const rewardType = String(prize.reward_type || prize.rewardType || "").toUpperCase();
    const isVoucher = rewardType === "VOUCHER_50";
    const title = String(prize.title || prize.name || prize.label || (isVoucher ? labels.voucherPrize : "")).trim();
    if (!title) return null;
    const handle = String(prize.handle || prize.product_handle || prize.productHandle || "").trim();
    const rawUrl = String(prize.url || prize.product_url || prize.productUrl || "").trim();
    const normalized = {
      productId: String(prize.product_id || prize.productId || ""),
      handle,
      url: handle ? `${rootPath.replace(/\/?$/, "/")}products/${encodeURIComponent(handle)}` : rawUrl,
      variantId: Number(prize.variant_id || prize.variantId || prize.id || 0),
      title,
      variant: String(prize.variant || prize.variant_title || ""),
      image: imageUrl(prize),
      visualKey: String(prize.visual_key || prize.visualKey || prize.key || prize.sku || prize.variant_id || prize.id || title),
      rewardType,
      isVoucher,
      amountCents: Number(prize.amount_cents || prize.amountCents || 0),
    };
    if (includeWeight) {
      normalized.weight = Math.max(0, Number(prize.weight) || 0);
      normalized.available = prize.available !== false;
      normalized.inventory = Number(prize.inventory ?? 1);
    }
    return normalized;
  };

  const labels = parseJson(component.querySelector("[data-bb-gift-labels]"), {});
  const previewPrizes = parseJson(component.querySelector("[data-bb-gift-preview-prizes]"), [])
    .map((prize) => normalizePrize(prize, true))
    .filter((prize) => prize && prize.weight > 0 && prize.available && prize.inventory > 0);

  const teaser = component.querySelector("[data-bb-gift-teaser]");
  const teaserDock = component.querySelector("[data-bb-gift-teaser-dock]");
  const teaserDismissButton = component.querySelector("[data-bb-gift-teaser-dismiss]");
  const backdrop = component.querySelector("[data-bb-gift-backdrop]");
  const sheet = component.querySelector("[data-bb-gift-sheet]");
  const sheetHandle = component.querySelector("[data-bb-gift-sheet-handle]");
  const closeButton = component.querySelector("[data-bb-gift-close]");
  const stage = component.querySelector("[data-bb-gift-stage]");
  const experience = component.querySelector("[data-bb-gift-experience]");
  const machine = component.querySelector("[data-bb-gift-machine]");
  const reelWindow = component.querySelector("[data-bb-gift-reel]");
  const reelTrack = component.querySelector("[data-bb-gift-reel-track]");
  const previousPrizeButton = component.querySelector("[data-bb-gift-previous]");
  const nextPrizeButton = component.querySelector("[data-bb-gift-next]");
  const spinButton = component.querySelector("[data-bb-gift-spin]");
  const confirmation = component.querySelector("[data-bb-gift-confirmation]");
  const result = component.querySelector("[data-bb-gift-result]");
  const resultMedia = component.querySelector("[data-bb-gift-result-media]");
  const resultEyebrow = component.querySelector("[data-bb-gift-result-eyebrow]");
  const resultTitle = component.querySelector("[data-bb-gift-result-title]");
  const resultText = component.querySelector("[data-bb-gift-result-text]");
  const intro = component.querySelector("[data-bb-gift-intro]");
  const progressValue = component.querySelector("[data-bb-gift-progress-value]");
  const progressStatus = component.querySelector("[data-bb-gift-progress-status]");
  const progressTrack = component.querySelector("[data-bb-gift-progress-track]");
  const progressFill = component.querySelector("[data-bb-gift-progress-fill]");
  const resetButton = component.querySelector("[data-bb-gift-reset]");
  const errorBox = component.querySelector("[data-bb-gift-error]");
  const liveRegion = component.querySelector("[data-bb-gift-live]");
  const confettiLayer = component.querySelector("[data-bb-gift-confetti]");
  const successEyebrow = resultEyebrow?.textContent || "";

  const previewStoragePrefix = "blankabric-gift-reveal-v3:";
  const attemptStoragePrefix = "blankabric-gift-attempt:";
  const revealedStoragePrefix = "blankabric-gift-revealed:";
  const teaserDismissedStorageKey = "blankabric-gift-teaser-dismissed";
  let isTeaserDismissed = false;
  try { isTeaserDismissed = window.sessionStorage.getItem(teaserDismissedStorageKey) === "true"; } catch (_error) {}
  let threshold = Number(component.dataset.threshold || 3900);
  let prizes = previewMode ? previewPrizes.slice() : [];
  let productionConfigCurrency = String(currency || "EUR").trim().toUpperCase();
  let currentCart = null;
  let productionConfigLoaded = previewMode;
  let productionConfigEnabled = previewMode;
  let configRequest = null;
  let statusGeneration = 0;
  let isBlocked = false;
  let isEligible = false;
  let hasPlayed = false;
  let hasRevealed = false;
  let drawStatusKnown = previewMode;
  let isDismissed = false;
  let hasWon = false;
  let previousPrize = null;
  let secureAward = null;
  let recoverableAward = null;
  let currentDrawId = "";
  let pendingCheckoutUrl = defaultCheckoutUrl;
  let giftCleanupNeeded = false;
  let checkoutValidationBlocked = false;
  let giftCleanupRequest = null;
  let giftRecoveryRequest = null;
  let giftAddRequest = null;
  let checkoutRequestInFlight = false;
  let isNavigating = false;
  let isSpinning = false;
  let isOpen = false;
  let teaserReady = false;
  let teaserTimer = 0;
  let teaserCollapseTimer = 0;
  let teaserHovered = false;
  let teaserKeyboardFocused = false;
  let lastFocusedElement = null;
  let currentPlan = null;
  let activeReelMotion = null;
  let resizeFrame = 0;
  let confettiTimer = 0;
  let lastGiftStateSignature = "";
  let cartSyncRequest = null;
  let queuedCartSync = null;
  let queuedCartSyncImmediate = false;
  const notifiedGiftCarts = new Set();
  let giftPromptOpening = false;

  const hasGiftProperty = (item) => String(item?.properties?._bb_gift_roulette || "") === "true";
  const giftGrant = (item) => String(item?.properties?._bb_gift_grant || "");
  const cartToken = (cart) => String(cart?.token || "").trim();
  const hasPrivateCartToken = (cart) => /\?key=[A-Za-z0-9_-]+/.test(cartToken(cart));
  const eligibleSubtotal = (cart) => (cart?.items || []).reduce(
    (sum, item) => hasGiftProperty(item) ? sum : sum + (Number(item.final_line_price) || 0),
    0,
  );
  const prizeKey = (prize) => String(prize?.visualKey || prize?.variantId || prize?.title || "");
  const samePrize = (first, second) => Boolean(first && second) && (
    (first.variantId > 0 && second.variantId > 0 && first.variantId === second.variantId) ||
    prizeKey(first) === prizeKey(second) || first.title === second.title
  );

  const dispatchGiftState = (state, prize) => {
    if (!prize) return;
    const rewardType = prize.rewardType || "WHITE_COUPON";
    const signature = [state, rewardType, prizeKey(prize), prize.title || ""].join(":");
    if (signature === lastGiftStateSignature) return;
    lastGiftStateSignature = signature;
    document.dispatchEvent(new CustomEvent("blankabric:gift-state", {
      detail: { state, prize, rewardType },
    }));
  };

  const announce = (message) => {
    if (!liveRegion) return;
    liveRegion.textContent = "";
    window.requestAnimationFrame(() => { liveRegion.textContent = String(message || ""); });
  };

  const showError = (message) => {
    if (!errorBox) return;
    errorBox.textContent = String(message || "");
    errorBox.hidden = !message;
  };

  const previewStorageKey = (cart) => `${previewStoragePrefix}${cartToken(cart) || "preview"}`;
  const readPreviewPrize = (cart) => {
    try {
      return normalizePrize(JSON.parse(window.sessionStorage.getItem(previewStorageKey(cart)) || "null"), true);
    } catch (_error) {
      return null;
    }
  };
  const storePreviewPrize = (cart, prize) => {
    try { window.sessionStorage.setItem(previewStorageKey(cart), JSON.stringify(prize)); } catch (_error) {}
  };
  const clearPreviewPrize = (cart) => {
    try { window.sessionStorage.removeItem(previewStorageKey(cart)); } catch (_error) {}
  };

  const revealStorageKey = (drawId) => `${revealedStoragePrefix}${String(drawId || "")}`;
  const readRevealMarker = (drawId) => {
    if (!drawId) return false;
    try { return window.localStorage.getItem(revealStorageKey(drawId)) === "1"; } catch (_error) { return false; }
  };
  const storeRevealMarker = (drawId) => {
    if (!drawId) return;
    try { window.localStorage.setItem(revealStorageKey(drawId), "1"); } catch (_error) {}
  };
  const dismissCurrentDraw = () => {
    isDismissed = true;
  };

  const getAttemptId = (cart) => {
    const key = `${attemptStoragePrefix}${cartToken(cart) || "unknown"}`;
    try {
      let attemptId = window.sessionStorage.getItem(key);
      if (!attemptId) {
        attemptId = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
        window.sessionStorage.setItem(key, attemptId);
      }
      return attemptId;
    } catch (_error) {
      return window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }
  };

  const apiUrl = (path, cart, query = {}) => {
    const url = new URL(`${apiBase}/${String(path || "").replace(/^\/+/, "")}`, window.location.origin);
    const token = cartToken(cart);
    if (token) url.searchParams.set("cart_token", token);
    if (currency) url.searchParams.set("currency", currency);
    if (locale) url.searchParams.set("locale", locale);
    Object.entries(query).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") url.searchParams.set(key, String(value));
    });
    return url.toString();
  };

  const apiRequest = async (path, { cart = currentCart, query } = {}) => {
    const response = await fetchWithTimeout(apiUrl(path, cart, query), {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    }, 8000);
    const payload = await response.json().catch(() => null);
    if (!response.ok || !payload) {
      const error = new Error("gift_api_error");
      error.debugCode = String(payload?.error || "gift_api_error");
      error.httpStatus = response.status;
      error.userMessage = labels.error || "";
      throw error;
    }
    return payload;
  };

  const fetchCart = async () => {
    const response = await fetchWithTimeout(`${rootPath}cart.js`, {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    }, 5000);
    if (!response.ok) throw new Error("cart_error");
    currentCart = await response.json();
    return currentCart;
  };

  const stabilizeCartIdentity = async (cart = currentCart) => {
    if (hasPrivateCartToken(cart)) return cart;
    const sessionId = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    const response = await fetchWithTimeout(`${rootPath}cart/update.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ attributes: { _bb_gift_session__: sessionId } }),
    }, 5000);
    if (!response.ok) throw new Error("cart_identity_error");
    const stableCart = await response.json();
    if (!hasPrivateCartToken(stableCart)) throw new Error("cart_identity_error");
    currentCart = stableCart;
    return stableCart;
  };

  const reelImageUrl = (source) => {
    const rawUrl = String(source || "").trim();
    if (!rawUrl) return "";
    try {
      const url = new URL(rawUrl, window.location.origin);
      const isShopifyImage = url.hostname === "cdn.shopify.com" || url.hostname.endsWith(".shopifycdn.com");
      if (!isShopifyImage) return rawUrl;
      url.searchParams.set("width", "520");
      url.searchParams.set("height", "520");
      url.searchParams.set("crop", "center");
      return url.toString();
    } catch (_error) {
      return rawUrl;
    }
  };

  const prizeImageCache = new Map();
  const prizeImageKey = (prize) => String(prize.handle || imageUrl(prize) || "");
  const loadPrizeImage = (url) => new Promise((resolve) => {
    if (!url) { resolve(false); return; }
    const image = new Image();
    let settled = false;
    const finish = (loaded) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timer);
      image.onload = image.onerror = null;
      resolve(loaded);
    };
    const timer = window.setTimeout(() => finish(false), 5000);
    image.onload = () => {
      if (typeof image.decode === "function") image.decode().catch(() => {}).then(() => finish(true));
      else finish(true);
    };
    image.onerror = () => finish(false);
    image.src = url;
  });

  const resolvePrizeImage = (prize) => {
    const key = prizeImageKey(prize);
    if (!key || prize.isVoucher) return Promise.resolve(null);
    if (prizeImageCache.has(key)) return prizeImageCache.get(key).request;
    const entry = { url: reelImageUrl(imageUrl(prize)), loaded: false, request: null };
    prizeImageCache.set(key, entry);
    entry.request = (async () => {
      if (!(await loadPrizeImage(entry.url))) {
        // The gift catalog can outlive a Shopify product photo. Recover the
        // current photo once per product, shared by every copy in the reel.
        try {
          if (!prize.handle) throw new Error("image_product_missing");
          const response = await fetchWithTimeout(`${rootPath.replace(/\/?$/, "/")}products/${encodeURIComponent(prize.handle)}.js`, {
            credentials: "same-origin", headers: { Accept: "application/json" },
          }, 5000);
          if (!response.ok) throw new Error("image_product_unavailable");
          const product = await response.json();
          const freshImage = product.featured_image || product.images?.[0];
          const source = typeof freshImage === "string" ? freshImage : freshImage?.src;
          entry.url = reelImageUrl(source);
          if (!(await loadPrizeImage(entry.url))) {
            entry.url = source ? new URL(source, window.location.origin).href : "";
            if (!(await loadPrizeImage(entry.url))) return null;
          }
        } catch (_error) { return null; }
      }
      entry.loaded = true;
      component.querySelectorAll("img[data-bb-prize-image]").forEach((image) => {
        if (image.dataset.bbPrizeImage !== key) return;
        if (image.getAttribute("src") !== entry.url) image.src = entry.url;
        image.classList.add("is-loaded");
      });
      return entry.url;
    })();
    return entry.request;
  };

  const primePrizeImages = async (catalog) => {
    const queue = (catalog || []).filter((prize) => !prize.isVoucher).slice();
    await Promise.allSettled(Array.from({ length: Math.min(6, queue.length) }, async () => {
      while (queue.length) await resolvePrizeImage(queue.shift());
    }));
  };

  const prizeMediaMarkup = (prize, alt = "") => {
    if (prize.isVoucher) return `<span class="bb-gift-roulette__voucher-value">${escapeHtml(formatCurrency(prize.amountCents || 2500))}</span>`;
    const cached = prizeImageCache.get(prizeImageKey(prize));
    const source = cached?.url || reelImageUrl(imageUrl(prize));
    const placeholder = '<svg class="bb-gift-roulette__image-placeholder" viewBox="0 0 64 64" aria-hidden="true"><path d="M14 13h30l7 12-7 26H14Z"/><path d="m14 13 23 13-23 25m23-25 7 25M14 34l30 17"/></svg>';
    return placeholder + (source ? `<img data-bb-prize-image="${escapeHtml(prizeImageKey(prize))}" data-product-handle="${escapeHtml(prize.handle)}" data-original-image="${escapeHtml(imageUrl(prize))}" class="${cached?.loaded ? "is-loaded" : ""}" src="${escapeHtml(source)}" alt="${escapeHtml(alt)}" width="520" height="520" loading="eager" decoding="async" draggable="false">` : "");
  };

  component.addEventListener("load", (event) => {
    const image = event.target;
    if (image instanceof HTMLImageElement && image.hasAttribute("data-bb-prize-image")) image.classList.add("is-loaded");
  }, true);
  component.addEventListener("error", (event) => {
    const image = event.target;
    if (!(image instanceof HTMLImageElement) || !image.hasAttribute("data-bb-prize-image")) return;
    image.classList.remove("is-loaded");
    void resolvePrizeImage({ handle: image.dataset.productHandle, image: image.dataset.originalImage });
  }, true);

  const cardMarkup = (prize, index, { interactive = false } = {}) => {
    const canOpenProduct = interactive && !prize.isVoucher && Boolean(prize.handle || prize.url);
    const tagName = canOpenProduct ? "button" : "div";
    const productAttributes = canOpenProduct
      ? ` type="button" data-bb-reel-product data-product-handle="${escapeHtml(prize.handle)}" data-product-url="${escapeHtml(prize.url)}" data-product-title="${escapeHtml(prize.title)}"`
      : "";
    return `
    <${tagName} class="bb-gift-roulette__reel-card" data-bb-reel-card-index="${index}"${productAttributes}>
      <span class="bb-gift-roulette__reel-card-media">
        ${prizeMediaMarkup(prize)}
      </span>
      <span class="bb-gift-roulette__reel-card-title">${escapeHtml(prize.title)}</span>
    </${tagName}>`;
  };

  const shuffle = (items) => {
    const next = items.slice();
    for (let index = next.length - 1; index > 0; index -= 1) {
      const values = new Uint32Array(1);
      window.crypto.getRandomValues(values);
      const swapIndex = values[0] % (index + 1);
      [next[index], next[swapIndex]] = [next[swapIndex], next[index]];
    }
    return next;
  };

  const ensurePrizeInCatalog = (prize) => {
    const existing = prizes.find((candidate) => samePrize(candidate, prize));
    if (existing) {
      Object.assign(existing, prize);
      return existing;
    }
    prizes = [prize, ...prizes];
    return prize;
  };

  const stopAnimations = () => {
    if (activeReelMotion?.frameId) window.cancelAnimationFrame(activeReelMotion.frameId);
    activeReelMotion = null;
    reelTrack?.classList.remove("is-moving");
    reelWindow?.classList.remove("is-stopped");
    reelWindow?.classList.remove("is-browsable");
    machine?.classList.remove("is-matched");
  };

  const translateForCard = (plan, cardIndex) => {
    const card = plan?.track?.querySelector(`[data-bb-reel-card-index="${cardIndex}"]`);
    if (!card) return 0;
    return plan.reelWindow.clientWidth / 2 - (card.offsetLeft + card.offsetWidth / 2);
  };

  const setTrackPosition = (plan, cardIndex) => {
    if (!plan) return;
    plan.track.style.transform = `translate3d(${translateForCard(plan, cardIndex)}px,0,0)`;
    plan.currentIndex = cardIndex;
  };

  const syncBrowseControls = () => {
    const visible = Boolean(currentPlan?.browsable && currentPlan.sequenceLength > 1 && !isSpinning);
    reelWindow?.classList.toggle("is-browsable", visible);
    reelWindow?.setAttribute("aria-hidden", String(!visible));
    if (previousPrizeButton) previousPrizeButton.hidden = !visible;
    if (nextPrizeButton) nextPrizeButton.hidden = !visible;
  };

  const buildMachine = (targetPrize = null, { mode = "browse" } = {}) => {
    if (!machine || !reelTrack || !reelWindow || !prizes.length) return null;
    stopAnimations();
    const target = targetPrize ? ensurePrizeInCatalog(targetPrize) : null;
    const distinct = prizes.filter((prize, index, catalog) =>
      catalog.findIndex((candidate) => samePrize(candidate, prize)) === index,
    );
    const voucherPrizes = distinct.filter((prize) => prize.isVoucher);
    const couponPrizes = distinct.filter((prize) => !prize.isVoucher);
    const browsable = !target && mode === "browse";
    const visualLimit = Math.max(1, Math.min(10, distinct.length));
    const visualPrizes = browsable
      ? shuffle([...couponPrizes, ...voucherPrizes])
      : shuffle([
          ...shuffle(couponPrizes).slice(0, Math.max(0, visualLimit - voucherPrizes.length)),
          ...voucherPrizes,
        ]);
    const sequence = browsable ? visualPrizes.slice() : [];
    let targetIndex = 0;
    if (!browsable) {
      const cycleCount = Math.ceil(180 / visualPrizes.length);
      for (let cycle = 0; cycle < cycleCount; cycle += 1) {
        const offset = (cycle * 2) % visualPrizes.length;
        const rotated = visualPrizes.slice(offset).concat(visualPrizes.slice(0, offset));
        sequence.push(...(cycle % 2 === 0 ? rotated : rotated.slice().reverse()));
      }
      targetIndex = Math.max(0, sequence.length - 1);
      if (target) {
        targetIndex = sequence.length;
        sequence.push(target);
        const trailingCards = shuffle(visualPrizes.filter((prize) => !samePrize(prize, target)));
        const trailingSource = trailingCards.length ? trailingCards : visualPrizes;
        for (let index = 0; index < 4; index += 1) {
          sequence.push(trailingSource[index % trailingSource.length]);
        }
      }
    }
    reelTrack.innerHTML = sequence.map((prize, index) => cardMarkup(prize, index, { interactive: browsable })).join("");
    const startIndex = browsable
      ? 0
      : Math.min(Math.max(0, visualPrizes.length), Math.max(0, sequence.length - 1));
    currentPlan = {
      track: reelTrack,
      reelWindow,
      startIndex,
      targetIndex,
      currentIndex: startIndex,
      sequenceLength: sequence.length,
      visualPrizes,
      browsable,
    };
    // Native browsing scroll must never offset the animated rail or its stop.
    reelWindow.style.scrollBehavior = "auto";
    reelWindow.scrollLeft = 0;
    reelWindow.style.removeProperty("scroll-behavior");
    if (browsable) {
      reelTrack.style.removeProperty("transform");
      reelWindow.scrollLeft = 0;
    } else {
      setTrackPosition(currentPlan, startIndex);
    }
    syncBrowseControls();
    return currentPlan;
  };

  const browsePrizes = (direction) => {
    const plan = currentPlan;
    if (!plan?.browsable || isSpinning || plan.sequenceLength < 2) return;
    const distance = Math.max(plan.reelWindow.clientWidth * 0.78, 240);
    plan.reelWindow.scrollBy({
      left: direction * distance,
      behavior: reducedMotion.matches ? "auto" : "smooth",
    });
  };

  let loadedProductPopup = null;
  let productPopupLoadToken = 0;

  const executeProductCardScripts = async (scripts) => {
    for (const source of scripts) {
      const script = document.createElement("script");
      Array.from(source.attributes).forEach((attribute) => {
        script.setAttribute(attribute.name, attribute.value);
      });
      if (source.src) {
        script.async = false;
        script.src = source.src;
        const loaded = new Promise((resolve, reject) => {
          script.addEventListener("load", resolve, { once: true });
          script.addEventListener("error", reject, { once: true });
        });
        document.head.append(script);
        await loaded;
      } else {
        script.textContent = source.textContent || "";
        document.head.append(script);
      }
    }
  };

  const loadProductPopup = async (localizedUrl, handle) => {
    if (loadedProductPopup?.handle === handle && loadedProductPopup.trigger?.isConnected) {
      return loadedProductPopup.trigger;
    }

    const loadToken = ++productPopupLoadToken;
    const sectionUrl = new URL(localizedUrl, window.location.origin);
    sectionUrl.searchParams.set("section_id", "blankabric-gift-product-card");
    const response = await fetchWithTimeout(sectionUrl.toString(), {
      credentials: "same-origin",
      headers: { Accept: "text/html" },
    }, 8000);
    if (!response.ok) throw new Error(`product_card_${response.status}`);

    const documentFragment = new DOMParser().parseFromString(await response.text(), "text/html");
    const sourceShell = documentFragment.querySelector("[data-bb-gift-product-card-shell]");
    if (!(sourceShell instanceof HTMLElement)) throw new Error("product_card_missing");

    const executableScripts = Array.from(
      sourceShell.querySelectorAll('script:not([type]), script[type="text/javascript"], script[type="module"]'),
    );
    executableScripts.forEach((script) => script.remove());

    if (loadToken !== productPopupLoadToken) throw new Error("product_card_superseded");
    loadedProductPopup?.shell?.remove();

    const shell = document.importNode(sourceShell, true);
    shell.classList.add("bb-gift-product-card-host");
    document.body.append(shell);

    if (!window.BBProductCardOptions?.init && executableScripts.length) {
      await executeProductCardScripts(executableScripts);
    }
    if (loadToken !== productPopupLoadToken) {
      shell.remove();
      throw new Error("product_card_superseded");
    }

    window.BBProductCardOptions?.init?.(shell);
    const trigger = shell.querySelector("[data-bb-open-options]");
    if (!(trigger instanceof HTMLButtonElement) || trigger.disabled) {
      shell.remove();
      throw new Error("product_card_trigger_missing");
    }

    loadedProductPopup = { handle, shell, trigger };
    return trigger;
  };

  const openPrizeProduct = async ({ handle, url }) => {
    if (!handle && !url) return;
    const localizedUrl = handle
      ? `${rootPath.replace(/\/?$/, "/")}products/${encodeURIComponent(handle)}`
      : url;
    const existingCard = Array.from(document.querySelectorAll("[data-bb-product-handle]")).find(
      (element) => element instanceof HTMLElement && element.dataset.productHandle === handle,
    )?.closest("[data-bb-product-card]");
    const existingTrigger = existingCard?.querySelector("[data-bb-open-options]");

    closeSheet({ restoreFocus: false });
    await wait(reducedMotion.matches ? 20 : 400);
    if (existingTrigger instanceof HTMLButtonElement && !existingTrigger.disabled) {
      existingTrigger.dispatchEvent(new CustomEvent("bb:open-options"));
      return;
    }
    try {
      const trigger = await loadProductPopup(localizedUrl, handle || localizedUrl);
      trigger.dispatchEvent(new CustomEvent("bb:open-options"));
    } catch (_error) {
      window.location.assign(localizedUrl);
    }
  };

  const startMysteryMotion = () => {
    const plan = buildMachine(null, { mode: "spin" });
    if (!plan) return null;
    const startX = translateForCard(plan, plan.startIndex);
    const nextIndex = Math.min(plan.sequenceLength - 1, plan.startIndex + 1);
    const cardStep = Math.max(1, Math.abs(translateForCard(plan, nextIndex) - startX));
    const endIndex = Math.max(plan.startIndex + 1, plan.sequenceLength - 4);
    const motion = {
      plan,
      frameId: 0,
      currentX: startX,
      lastTime: 0,
      speed: cardStep / 80,
      endX: translateForCard(plan, endIndex),
      phase: "cruise",
      stopStartX: startX,
      stopTargetX: startX,
      stopStartedAt: 0,
      stopDuration: 0,
      resolveStop: null,
    };
    activeReelMotion = motion;
    plan.track.classList.add("is-moving");
    plan.track.style.transform = `translate3d(${startX}px,0,0)`;

    if (reducedMotion.matches) return motion;

    const renderFrame = (timestamp) => {
      if (activeReelMotion !== motion) return;
      if (!motion.lastTime) motion.lastTime = timestamp;
      const delta = Math.max(0, timestamp - motion.lastTime);
      motion.lastTime = timestamp;

      if (motion.phase === "cruise") {
        if (motion.currentX - motion.endX < motion.speed * 4500) {
          const extension = Array.from({ length: 60 }, (_, index) => cardMarkup(plan.visualPrizes[index % plan.visualPrizes.length], plan.sequenceLength + index)).join("");
          plan.track.insertAdjacentHTML("beforeend", extension);
          plan.sequenceLength += 60;
          motion.endX = translateForCard(plan, plan.sequenceLength - 4);
        }
        motion.currentX = Math.max(motion.endX, motion.currentX - motion.speed * delta);
      } else {
        if (!motion.stopStartedAt) motion.stopStartedAt = timestamp;
        const elapsed = Math.min(motion.stopDuration, timestamp - motion.stopStartedAt);
        const progress = elapsed / motion.stopDuration;
        // Integral of 1 - smoothstep(progress): continuous speed AND acceleration.
        const distance = motion.speed * motion.stopDuration * (progress - progress ** 3 + 0.5 * progress ** 4);
        motion.currentX = Math.max(motion.stopTargetX, motion.stopStartX - distance);
      }

      plan.track.style.transform = `translate3d(${motion.currentX}px,0,0)`;

      if (motion.phase === "stopping" && timestamp - motion.stopStartedAt >= motion.stopDuration) {
        motion.currentX = motion.stopTargetX;
        plan.track.style.transform = `translate3d(${motion.stopTargetX}px,0,0)`;
        activeReelMotion = null;
        const resolve = motion.resolveStop;
        motion.resolveStop = null;
        resolve?.();
        return;
      }
      motion.frameId = window.requestAnimationFrame(renderFrame);
    };
    motion.frameId = window.requestAnimationFrame(renderFrame);
    return motion;
  };

  const animateToPrize = async (prize, motion = activeReelMotion) => {
    const plan = motion?.plan;
    if (!plan) throw new Error("machine_configuration_error");
    const targetPrize = ensurePrizeInCatalog(prize);
    const idealDistance = motion.speed * 1900;
    const finalUsableIndex = Math.max(plan.startIndex + 1, plan.sequenceLength - 5);
    let targetIndex = finalUsableIndex;
    for (let index = plan.startIndex + 1; index <= finalUsableIndex; index += 1) {
      const distance = motion.currentX - translateForCard(plan, index);
      if (distance >= idealDistance) {
        targetIndex = index;
        break;
      }
    }

    const targetCard = plan.track.querySelector(`[data-bb-reel-card-index="${targetIndex}"]`);
    if (!targetCard) throw new Error("machine_target_missing");
    targetCard.outerHTML = cardMarkup(targetPrize, targetIndex);
    plan.targetIndex = targetIndex;

    const targetX = translateForCard(plan, targetIndex);
    if (reducedMotion.matches) {
      activeReelMotion = null;
      setTrackPosition(plan, targetIndex);
    } else {
      const distance = Math.max(1, motion.currentX - targetX);
      motion.phase = "stopping";
      motion.stopStartX = motion.currentX;
      motion.stopTargetX = targetX;
      motion.stopStartedAt = motion.lastTime || window.performance.now();
      motion.stopDuration = Math.max(1, (2 * distance) / motion.speed);
      await new Promise((resolve) => { motion.resolveStop = resolve; });
    }
    plan.track.classList.remove("is-moving");
    plan.track.querySelector(`[data-bb-reel-card-index="${plan.targetIndex}"]`)?.classList.add("is-selected");
    plan.reelWindow.classList.add("is-stopped");
    machine.classList.add("is-matched");
    plan.currentIndex = plan.targetIndex;
  };

  const clearConfetti = () => {
    window.clearTimeout(confettiTimer);
    confettiTimer = 0;
    confettiLayer?.replaceChildren();
    confettiLayer?.classList.remove("is-active");
  };

  const launchConfetti = () => {
    clearConfetti();
    if (!confettiLayer || reducedMotion.matches) return;
    const colors = ["#711426", "#a7475b", "#d9b9a7", "#f3ddc9", "#fffaf3"];
    const fragment = document.createDocumentFragment();
    for (let index = 0; index < 68; index += 1) {
      const particle = document.createElement("i");
      particle.className = `bb-gift-roulette__confetti-piece${index % 7 === 0 ? " is-round" : ""}${index % 5 === 0 ? " is-diamond" : ""}`;
      const drift = -130 + Math.random() * 260;
      particle.style.setProperty("--bb-confetti-x", `${2 + Math.random() * 96}%`);
      particle.style.setProperty("--bb-confetti-drift", `${drift}px`);
      particle.style.setProperty("--bb-confetti-drift-mid", `${drift * -0.28}px`);
      particle.style.setProperty("--bb-confetti-spin", `${420 + Math.random() * 920}deg`);
      particle.style.setProperty("--bb-confetti-delay", `${Math.random() * 300}ms`);
      particle.style.setProperty("--bb-confetti-duration", `${1900 + Math.random() * 1200}ms`);
      particle.style.setProperty("--bb-confetti-color", colors[index % colors.length]);
      particle.style.setProperty("--bb-confetti-scale", String(0.72 + Math.random() * 0.65));
      fragment.appendChild(particle);
    }
    confettiLayer.appendChild(fragment);
    confettiLayer.classList.add("is-active");
    confettiTimer = window.setTimeout(clearConfetti, 3700);
  };

  const normalizeAward = (payload) => {
    const root = payload?.data || payload || {};
    const award = root.award || root.result || root;
    const rewardType = String(award.reward_type || award.rewardType || root.reward_type || root.rewardType || "").toUpperCase();
    const voucher = award.voucher || root.voucher || null;
    const prizeSource = award.prize || root.prize || (rewardType === "VOUCHER_50" ? {
      ...voucher,
      key: "VOUCHER_50",
      reward_type: "VOUCHER_50",
      title: labels.voucherPrize || "",
    } : null);
    const prize = normalizePrize(prizeSource);
    const variantId = Number(prizeSource?.variant_id || prizeSource?.variantId || award.variant_id || award.variantId || root.variant_id || root.variantId || prize?.variantId || 0);
    const normalized = prize ? { ...prize, variantId } : null;
    const drawId = String(award.draw_id || award.drawId || root.draw_id || root.drawId || "");
    if (!normalized && !drawId) return null;
    return {
      prize: normalized,
      variantId,
      grant: String(award.grant || award.grant_token || root.grant || root.grant_token || ""),
      code: String(award.code || award.discount_code || award.discountCode || root.code || root.discount_code || root.discountCode || ""),
      checkoutUrl: String(award.checkout_url || award.checkoutUrl || root.checkout_url || root.checkoutUrl || ""),
      drawId,
      rewardType: prize?.rewardType || rewardType,
      isVoucher: Boolean(prize?.isVoucher || rewardType === "VOUCHER_50"),
    };
  };

  const applyProductionConfig = (payload) => {
    const config = payload?.config || payload?.data?.config || payload?.data || payload || {};
    productionConfigEnabled = config.enabled !== false;
    productionConfigCurrency = String(config.currency || productionConfigCurrency || "EUR").trim().toUpperCase();
    threshold = Number(config.threshold_cents || config.thresholdCents || config.threshold || threshold);
    const visualPrizes = config.visual_prizes || config.visualPrizes || config.prizes || [];
    prizes = Array.isArray(visualPrizes) ? visualPrizes.map((prize) => normalizePrize(prize)).filter(Boolean) : [];
    productionConfigLoaded = true;
    void primePrizeImages(prizes);
    document.dispatchEvent(new CustomEvent("blankabric:gift-config", {
      detail: {
        enabled: productionConfigEnabled,
        thresholdCents: threshold,
        jackpotEnabled: Boolean(config.jackpotEnabled || config.jackpot_enabled),
      },
    }));
    if (!isSpinning && prizes.length) buildMachine();
    return productionConfigEnabled && prizes.length > 0;
  };

  const loadProductionConfig = async (cart, { force = false } = {}) => {
    if (previewMode) return true;
    if (productionConfigLoaded && !force) return productionConfigEnabled && prizes.length > 0;
    if (configRequest) return configRequest;
    const requestConfig = () => apiRequest("/gifts/config", {
      cart,
      query: { experience: "floating-v3" },
    });
    configRequest = requestConfig()
      .catch(async (firstError) => {
        await wait(320);
        try {
          return await requestConfig();
        } catch (_retryError) {
          throw firstError;
        }
      })
      .then(applyProductionConfig)
      .catch((error) => {
        console.error("[Blankabric Gift] Configuration indisponible", {
          code: error?.debugCode || error?.message || "unknown",
          status: Number(error?.httpStatus || 0),
        });
        productionConfigLoaded = false;
        productionConfigEnabled = false;
        prizes = [];
        return false;
      })
      .finally(() => { configRequest = null; });
    return configRequest;
  };

  const applyProductionStatus = (payload, cart = currentCart) => {
    drawStatusKnown = true;
    const root = payload?.data || payload || {};
    const status = root.status && typeof root.status === "object" ? root.status : root;
    const merged = { ...root, ...status, award: status.award || root.award, prize: status.prize || root.prize };
    const state = String(typeof root.status === "string" ? root.status : merged.state || "").toLowerCase();
    const award = normalizeAward(merged);
    checkoutValidationBlocked = merged.checkoutBlocked === true || merged.checkout_blocked === true || merged.revocationPending === true || merged.revocation_pending === true;
    isBlocked = merged.blocked === true || state === "blocked" || state === "excluded";
    isEligible = !isBlocked && (
      merged.thresholdReached === true ||
      merged.threshold_reached === true ||
      eligibleSubtotal(cart) >= threshold
    );

    if (merged.hasDraw === false || merged.has_draw === false) {
      lastGiftStateSignature = "";
      hasPlayed = false;
      hasRevealed = false;
      hasWon = false;
      previousPrize = null;
      secureAward = null;
      recoverableAward = null;
      currentDrawId = "";
      pendingCheckoutUrl = defaultCheckoutUrl;
      giftCleanupNeeded = (cart?.items || []).some(hasGiftProperty);
      return true;
    }

    const hasRecordedDraw = Boolean(award?.drawId && award?.prize);
    hasPlayed = merged.played === true || state === "revealed" || hasRecordedDraw;
    const nextDrawId = award?.drawId || currentDrawId;
    if (hasPlayed && award?.prize) previousPrize = ensurePrizeInCatalog(award.prize);
    else if (!hasPlayed) previousPrize = null;
    currentDrawId = nextDrawId;
    hasRevealed = hasPlayed && Boolean(previousPrize);
    const completeAward = award?.isVoucher
      ? Boolean(award.prize && award.checkoutUrl)
      : Boolean(award?.prize && award.checkoutUrl && award.code && award.variantId > 0 && award.grant);
    hasWon = !isBlocked && completeAward && ["won", "awarded", "added_to_cart"].includes(state);
    const cartBoundAward = completeAward ? { ...award, cartToken: cartToken(cart) } : null;
    if (cartBoundAward) recoverableAward = cartBoundAward;
    secureAward = hasWon ? cartBoundAward : null;
    pendingCheckoutUrl = secureAward?.checkoutUrl || defaultCheckoutUrl;
    giftCleanupNeeded = (cart?.items || []).some(hasGiftProperty) && !hasWon;
    return true;
  };

  const loadProductionStatus = async (cart) => {
    if (previewMode) return true;
    const generation = ++statusGeneration;
    try {
      const payload = await apiRequest("/gifts/status", {
        cart,
        query: { experience: "floating-v3" },
      });
      if (generation !== statusGeneration) return false;
      return applyProductionStatus(payload, cart);
    } catch (error) {
      console.error("[Blankabric Gift] Statut indisponible", {
        code: error?.debugCode || error?.message || "unknown",
        status: Number(error?.httpStatus || 0),
      });
      if (generation === statusGeneration) {
        drawStatusKnown = false;
        isEligible = false;
        giftCleanupNeeded = (cart?.items || []).some(hasGiftProperty);
      }
      return false;
    }
  };

  const requestSecureReveal = async (cart) => {
    const token = cartToken(cart);
    if (!token) throw new Error("cart_token_missing");
    const payload = await apiRequest("/gifts/reveal", {
      cart,
      query: {
        intent: "reveal",
        idempotency_key: getAttemptId(cart),
        draw_id: currentDrawId || undefined,
      },
    });
    const award = normalizeAward(payload);
    if (!award?.prize || !award.drawId || (!award.isVoucher && award.variantId <= 0)) {
      const error = new Error("invalid_gift_reveal");
      error.userMessage = labels.configurationError || labels.error || "";
      throw error;
    }
    award.prize = ensurePrizeInCatalog(award.prize);
    award.cartToken = token;
    currentDrawId = award.drawId;
    if ((award.isVoucher && award.checkoutUrl) || (award.checkoutUrl && award.code && award.grant)) {
      secureAward = award;
      recoverableAward = award;
      pendingCheckoutUrl = award.checkoutUrl;
      hasWon = true;
    }
    return award;
  };

  const requestSecureActivation = async (cart) => {
    const token = cartToken(cart);
    if (!token || !currentDrawId) throw new Error("gift_activation_identity_missing");
    const payload = await apiRequest("/gifts/spin", {
      cart,
      query: {
        intent: "draw",
        idempotency_key: getAttemptId(cart),
        draw_id: currentDrawId,
      },
    });
    const award = normalizeAward(payload);
    const completeAward = award?.isVoucher
      ? Boolean(award.prize && award.checkoutUrl)
      : Boolean(award?.prize && award.checkoutUrl && award.code && award.variantId > 0 && award.grant);
    if (!completeAward || (award.drawId && award.drawId !== currentDrawId)) {
      const error = new Error("invalid_gift_activation");
      error.userMessage = labels.configurationError || labels.error || "";
      throw error;
    }
    award.prize = ensurePrizeInCatalog(award.prize);
    award.cartToken = token;
    secureAward = award;
    recoverableAward = award;
    pendingCheckoutUrl = award.checkoutUrl;
    hasWon = true;
    return award;
  };

  const requestUnavailableGiftReplacement = async (cart, award) => {
    const payload = await apiRequest("/gifts/replace", {
      cart,
      query: {
        intent: "replace_unavailable",
        idempotency_key: getAttemptId(cart),
        draw_id: award?.drawId || currentDrawId,
      },
    });
    const replacement = normalizeAward(payload);
    const completeAward = Boolean(
      replacement?.prize &&
      replacement.checkoutUrl &&
      replacement.code &&
      replacement.variantId > 0 &&
      replacement.grant
    );
    if (!completeAward || (replacement.drawId && replacement.drawId !== currentDrawId)) {
      const error = new Error("invalid_gift_replacement");
      error.userMessage = labels.configurationError || labels.error || "";
      throw error;
    }
    replacement.prize = ensurePrizeInCatalog(replacement.prize);
    replacement.cartToken = cartToken(cart);
    currentDrawId = replacement.drawId;
    previousPrize = replacement.prize;
    secureAward = replacement;
    recoverableAward = replacement;
    pendingCheckoutUrl = replacement.checkoutUrl;
    hasWon = true;
    return replacement;
  };

  const giftDrawId = (item) => String(item?.properties?._bb_gift_draw_id || "");
  const giftLineMatchesAward = (item, award) => Boolean(
    hasGiftProperty(item) &&
    award?.grant &&
    giftGrant(item) === award.grant &&
    Number(item?.variant_id || item?.id || 0) === Number(award.variantId || 0) &&
    (!award.drawId || giftDrawId(item) === award.drawId)
  );
  const cartHasGrant = (cart, grant) => Boolean(grant) && (cart?.items || []).some((item) => giftGrant(item) === grant);
  const cartHasAwardedGift = (cart = currentCart, award = secureAward) => {
    const giftLines = (cart?.items || []).filter(hasGiftProperty);
    if (giftLines.length !== 1) return false;
    return giftLines.some((item) => {
      const matchesGrant = Boolean(award?.grant) && giftGrant(item) === award.grant;
      const matchesDraw = Boolean(currentDrawId) && giftDrawId(item) === currentDrawId;
      return (matchesGrant || matchesDraw) && Number(item.quantity) === 1 && Number(item.final_line_price) === 0;
    });
  };

  const normalizeGiftLinesForAward = async (cart, award) => {
    const giftLines = (cart?.items || []).filter(hasGiftProperty);
    const updates = {};
    let keptMatchingLine = false;
    giftLines.forEach((item) => {
      if (!item.key) return;
      const matches = giftLineMatchesAward(item, award);
      if (matches && !keptMatchingLine) {
        keptMatchingLine = true;
        if (Number(item.quantity) !== 1) updates[item.key] = 1;
      } else {
        updates[item.key] = 0;
      }
    });
    if (!Object.keys(updates).length) return cart;
    const response = await fetch(`${rootPath}cart/update.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates }),
    });
    if (!response.ok) throw Object.assign(new Error("gift_normalization_error"), { userMessage: labels.error || "" });
    return response.json();
  };

  const removeInvalidGiftLines = async (cart = currentCart) => {
    const updates = {};
    (cart?.items || []).forEach((item) => { if (hasGiftProperty(item) && item.key) updates[item.key] = 0; });
    if (!Object.keys(updates).length) {
      giftCleanupNeeded = false;
      return cart;
    }
    if (giftCleanupRequest) return giftCleanupRequest;
    giftCleanupRequest = fetch(`${rootPath}cart/update.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates }),
    }).then(async (response) => {
      if (!response.ok) throw new Error("gift_cleanup_error");
      currentCart = await response.json();
      giftCleanupNeeded = false;
      document.dispatchEvent(new CustomEvent("blankabric:cart-updated", {
        detail: { cart: currentCart, source: "gift-cleanup" },
      }));
      return currentCart;
    }).finally(() => { giftCleanupRequest = null; });
    return giftCleanupRequest;
  };

  const addGrantedGiftOnce = async (award, { replacementAttempted = false } = {}) => {
    if (!award?.variantId || !award.grant || !award.code) {
      const error = new Error("invalid_gift_grant");
      error.userMessage = labels.configurationError || labels.error || "";
      throw error;
    }
    let freshCart = await fetchCart();
    freshCart = await normalizeGiftLinesForAward(freshCart, award);
    if (!cartHasGrant(freshCart, award.grant)) {
      const properties = {
        _bb_gift_roulette: "true",
        _bb_gift_grant: award.grant,
        _bb_gift_code: award.code,
        _bb_gift_prize: award.prize?.title || "",
        _bb_gift_draw_id: award.drawId || currentDrawId,
      };
      const response = await fetch(`${rootPath}cart/add.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: award.variantId, quantity: 1, properties }] }),
      });
      if (!response.ok) {
        const detail = await response.json().catch(() => null);
        if (response.status === 422 && !replacementAttempted) {
          const replacement = await requestUnavailableGiftReplacement(freshCart, award);
          if (replacement.variantId !== award.variantId || replacement.grant !== award.grant) {
            return addGrantedGiftOnce(replacement, { replacementAttempted: true });
          }
        }
        const error = new Error("gift_add_error");
        error.debugCode = `gift_add_error:${response.status}:${String(detail?.description || detail?.message || "unknown").slice(0, 180)}`;
        error.httpStatus = response.status;
        error.userMessage = labels.error || "";
        throw error;
      }
    }
    const discountRetryDelays = [0, 300, 700, 1200];
    let freeGiftIsVerified = false;
    for (const delay of discountRetryDelays) {
      if (delay > 0) await wait(delay);
      const discountResponse = await fetch(`${rootPath}cart/update.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ discount: award.code }),
      });
      if (!discountResponse.ok) continue;
      try {
        currentCart = await discountResponse.json();
      } catch (_error) {
        currentCart = await fetchCart();
      }
      currentCart = await normalizeGiftLinesForAward(currentCart, award);
      freeGiftIsVerified = (currentCart.items || []).some((item) => (
        giftLineMatchesAward(item, award) && Number(item.quantity) === 1 && Number(item.final_line_price) === 0
      )) && (currentCart.items || []).filter(hasGiftProperty).length === 1;
      if (freeGiftIsVerified) break;
    }
    if (!freeGiftIsVerified) {
      throw Object.assign(new Error("gift_discount_not_applied"), { userMessage: labels.error || "" });
    }

    const confirmAddition = () => apiRequest("/gifts/added", {
      cart: currentCart,
      query: { intent: "confirm", draw_id: award.drawId, grant: award.grant },
    });
    try {
      await confirmAddition();
    } catch (_error) {
      // The cart is already verified as free. Do not block the customer if the
      // acknowledgement response times out; retry it in the background instead.
      window.setTimeout(() => confirmAddition().catch(() => {}), 1200);
    }
    return currentCart;
  };

  const addGrantedGift = (award) => {
    if (giftAddRequest) return giftAddRequest;
    // Do not wait on a cross-tab Web Lock here: a suspended tab can retain it
    // and prevent the gift from ever returning until the page is refreshed.
    // Server idempotency plus normalizeGiftLinesForAward still guarantees one
    // free line, even if two tabs happen to attempt the recovery together.
    giftAddRequest = addGrantedGiftOnce(award).finally(() => { giftAddRequest = null; });
    return giftAddRequest;
  };

  const refreshCartInterface = async () => {
    try {
      const refreshed = await window.BlankabricCartDrawer?.refresh?.();
      if (refreshed) currentCart = refreshed;
    } catch (_error) {}
  };

  const selectPreviewPrize = () => {
    const total = prizes.reduce((sum, prize) => sum + Number(prize.weight || 0), 0);
    if (total <= 0) return prizes[0] || null;
    const values = new Uint32Array(1);
    window.crypto.getRandomValues(values);
    let cursor = (values[0] / 4294967296) * total;
    for (const prize of prizes) {
      cursor -= Number(prize.weight || 0);
      if (cursor < 0) return prize;
    }
    return prizes[prizes.length - 1];
  };

  const currentRemainingText = () => formatLabel(labels.remaining || "", {
    amount: formatCurrency(Math.max(0, threshold - eligibleSubtotal(currentCart))),
    threshold: formatCurrency(threshold),
  });

  const currentResultText = () => {
    if (previousPrize?.isVoucher) {
      return isEligible && hasWon
        ? labels.voucherResultText || labels.resultText || ""
        : formatLabel(labels.remaining || "", { amount: formatCurrency(threshold), threshold: formatCurrency(threshold) });
    }
    if (cartHasAwardedGift()) return labels.resultText || "";
    if (isEligible) return labels.adding || "";
    return formatLabel(labels.couponLockedResult || labels.remaining || "", {
      product: previousPrize?.title || "",
      threshold: formatCurrency(threshold),
    });
  };

  const syncProgress = () => {
    const subtotal = Math.max(0, eligibleSubtotal(currentCart));
    const cappedSubtotal = Math.min(threshold, subtotal);
    const percent = threshold > 0 ? Math.min(100, Math.max(0, (subtotal / threshold) * 100)) : 0;
    if (intro) {
      intro.textContent = labels.playNowUnlock || "";
    }
    if (progressValue) {
      progressValue.textContent = `${formatCurrency(cappedSubtotal)} / ${formatCurrency(threshold)}`;
    }
    if (progressStatus) {
      progressStatus.textContent = cartHasAwardedGift() && hasRevealed
        ? labels.resultText || ""
        : isEligible
          ? hasRevealed
            ? labels.adding || labels.unlocked || ""
            : labels.unlocked || ""
          : currentRemainingText();
    }
    if (progressTrack) progressTrack.setAttribute("aria-valuenow", String(Math.round(percent)));
    if (progressFill) progressFill.style.width = `${percent}%`;
    syncGiftPrompts();
  };

  const showExperience = ({ rebuild = false } = {}) => {
    component.classList.remove("is-complete", "is-confirming");
    if (confirmation) {
      confirmation.textContent = labels.resultText || "";
      confirmation.hidden = true;
    }
    if (spinButton) spinButton.disabled = isSpinning || isBlocked || (hasPlayed && hasRevealed);
    if (result) result.hidden = true;
    if (experience) experience.hidden = false;
    if ((rebuild || !currentPlan) && prizes.length) buildMachine();
    syncProgress();
  };

  const showResult = (prize, { focus = false, text } = {}) => {
    if (!prize || !result || !resultTitle || !resultMedia) return;
    if (experience) experience.hidden = true;
    result.hidden = false;
    component.classList.add("is-complete");
    if (resultEyebrow) {
      resultEyebrow.textContent = successEyebrow || labels.won || "";
    }
    resultTitle.textContent = prize.title;
    resultText.textContent = text === undefined ? currentResultText() : text;
    resultMedia.innerHTML = prizeMediaMarkup(prize, formatLabel(prize.isVoucher ? labels.voucherImageAlt : labels.imageAlt || "", { product: prize.title }));
    void resolvePrizeImage(prize);
    announce(`${prize.title} ${resultText.textContent}`.trim());
    dispatchGiftState(cartHasAwardedGift() ? "won" : "reserved", prize);
    syncProgress();
    if (focus && isOpen) window.requestAnimationFrame(() => resultTitle.focus());
  };

  const configCurrencyMatches = () => productionConfigCurrency === String(currency || "EUR").trim().toUpperCase();

  const canSurface = () => Boolean(
    currentCart &&
    productionConfigEnabled &&
    configCurrencyMatches() &&
    prizes.length &&
    !isBlocked &&
    (
      !(currentCart.items || []).some(hasGiftProperty) ||
      (hasRevealed && cartHasAwardedGift())
    ),
  );

  const syncTeaserContent = () => {
    const prize = hasRevealed ? previousPrize : null;
    component.classList.toggle("is-reserved", Boolean(prize && !hasWon));
    component.classList.toggle("is-unlocked", Boolean(isEligible));
  };

  const syncGiftPrompts = () => {
    const eligible = currentCart && eligibleSubtotal(currentCart) >= threshold;
    const added = !previewMode && cartHasAwardedGift();
    const voucherReady = hasRevealed && hasWon && secureAward?.isVoucher;
    const confirmed = added || voucherReady;
    const visible = eligible && productionConfigEnabled && configCurrencyMatches() && !isBlocked;
    document.querySelectorAll('[data-bb-gift-prompt]').forEach((prompt) => {
      prompt.hidden = !visible;
      if (!visible) return;
      prompt.classList.toggle('is-added', Boolean(confirmed));
      const title = prompt.querySelector('[data-bb-gift-prompt-title]');
      const text = prompt.querySelector('[data-bb-gift-prompt-text]');
      const button = prompt.querySelector('[data-bb-gift-open]');
      const nextTitle = confirmed ? labels.claimAddedTitle : hasRevealed ? labels.claimPendingTitle : labels.claimTitle;
      const nextText = voucherReady ? labels.voucherResultText : added ? labels.claimAddedText : hasRevealed ? labels.claimPendingText : labels.claimText;
      if (title && title.textContent !== nextTitle) title.textContent = nextTitle || '';
      if (text && text.textContent !== nextText) text.textContent = nextText || '';
      if (button) {
        button.hidden = Boolean(confirmed);
        button.textContent = hasRevealed ? labels.claimPendingAction : labels.claimAction;
      }
    });
  };

  const giftNoticeKey = () => `blankabric-gift-notice:${cartToken(currentCart).split('?')[0]}`;
  const markGiftNoticeSeen = () => {
    const key = giftNoticeKey();
    notifiedGiftCarts.add(key);
    try { window.sessionStorage.setItem(key, 'true'); } catch (_error) {}
  };
  const maybePromptForGift = () => {
    if (isTeaserDismissed || !drawStatusKnown || !isEligible || hasPlayed || hasRevealed || isOpen || isSpinning || !canSurface() || document.visibilityState === 'hidden') return;
    const key = giftNoticeKey();
    if (notifiedGiftCarts.has(key)) return;
    try { if (window.sessionStorage.getItem(key) === 'true') return; } catch (_error) {}
    openSheet({ attention: true });
  };

  // Keep checkout/gift recovery active on product pages, without a floating tab.
  // An existing draw is never advertised again, even below the cart threshold.
  const canShowTeaser = () =>
    !isTeaserDismissed && component.dataset.pageType !== "product" && drawStatusKnown && !hasPlayed && !hasRevealed && canSurface();

  const collapseTeaser = () => {
    window.clearTimeout(teaserCollapseTimer);
    component.classList.remove("is-teaser-expanded");
    if (teaserDismissButton) teaserDismissButton.tabIndex = -1;
  };

  const scheduleTeaserCollapse = () => {
    window.clearTimeout(teaserCollapseTimer);
    teaserCollapseTimer = window.setTimeout(() => {
      if (!teaserHovered && !teaserKeyboardFocused) collapseTeaser();
    }, 4000);
  };

  const revealTeaser = () => {
    if (!teaserDock || teaserDock.hidden || isOpen || isTeaserDismissed) return;
    component.classList.add("is-teaser-expanded");
    if (teaserDismissButton) teaserDismissButton.tabIndex = 0;
    scheduleTeaserCollapse();
  };

  const refreshTeaserVisibility = () => {
    const visible = teaserReady && !isDismissed && canShowTeaser();
    component.hidden = (!canShowTeaser() || isDismissed) && !isOpen;
    const nextAriaHidden = String(component.hidden);
    if (component.getAttribute("aria-hidden") !== nextAriaHidden) {
      component.setAttribute("aria-hidden", nextAriaHidden);
    }
    if (teaser) teaser.hidden = !visible || isOpen;
    if (teaserDock) teaserDock.hidden = !visible || isOpen;
    component.classList.toggle("is-teaser-visible", visible && !isOpen);
    if (visible && !isOpen && !component.classList.contains("is-teaser-introduced")) {
      component.classList.add("is-teaser-introduced");
      revealTeaser();
    } else if (!visible || isOpen) {
      collapseTeaser();
    }
  };

  const dismissTeaser = () => {
    isTeaserDismissed = true;
    teaserReady = false;
    window.clearTimeout(teaserTimer);
    collapseTeaser();
    try { window.sessionStorage.setItem(teaserDismissedStorageKey, "true"); } catch (_error) {}
    refreshTeaserVisibility();
  };

  const scheduleTeaser = ({ immediate = false } = {}) => {
    window.clearTimeout(teaserTimer);
    if (!canShowTeaser() || isDismissed) {
      teaserReady = false;
      refreshTeaserVisibility();
      return;
    }
    if (teaserReady) {
      refreshTeaserVisibility();
      return;
    }
    const elapsedSinceArrival = Math.max(0, window.performance?.now?.() || 0);
    const remainingDelay = immediate ? 350 : Math.max(0, teaserDelay - elapsedSinceArrival);
    teaserTimer = window.setTimeout(() => {
      teaserReady = true;
      refreshTeaserVisibility();
    }, remainingDelay);
  };

  const openSheet = ({ focus = true, attention = false } = {}) => {
    if (!canSurface() || isOpen) return;
    // An interrupted introduction must not replay when the customer closes the game.
    if (teaserReady) component.classList.add("is-teaser-introduced");
    if (isEligible) markGiftNoticeSeen();
    isOpen = true;
    lastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    component.hidden = false;
    component.setAttribute("aria-hidden", "false");
    teaser.hidden = true;
    if (teaserDock) teaserDock.hidden = true;
    collapseTeaser();
    teaser.setAttribute("aria-expanded", "true");
    sheet.hidden = false;
    backdrop.hidden = false;
    document.body.classList.add("bb-gift-sheet-open");
    component.classList.add("is-open");
    if (attention) component.classList.add("is-attention");
    if (previousPrize && hasRevealed && !isSpinning) showResult(previousPrize);
    else showExperience({ rebuild: true });
    window.requestAnimationFrame(() => {
      component.classList.add("is-open-ready");
      if (focus) (previousPrize && hasRevealed ? resultTitle : spinButton)?.focus({ preventScroll: true });
    });
  };

  const closeSheet = ({ restoreFocus = true, showCart = false } = {}) => {
    if (!isOpen || isSpinning) return;
    isOpen = false;
    clearConfetti();
    component.classList.remove("is-open-ready", "is-attention");
    teaser.setAttribute("aria-expanded", "false");
    document.body.classList.remove("bb-gift-sheet-open");
    sheet.style.removeProperty("transform");
    backdrop.style.removeProperty("opacity");
    window.setTimeout(() => {
      if (isOpen) return;
      sheet.hidden = true;
      backdrop.hidden = true;
      component.classList.remove("is-open");
      refreshTeaserVisibility();
      if (showCart) window.BlankabricCartDrawer?.open?.();
    }, reducedMotion.matches ? 0 : 380);
    if (restoreFocus && lastFocusedElement?.isConnected) lastFocusedElement.focus({ preventScroll: true });
  };

  const renderState = ({ immediate = false } = {}) => {
    if (!currentCart) return;
    isEligible = !isBlocked && eligibleSubtotal(currentCart) >= threshold;
    syncTeaserContent();
    syncProgress();
    if (isOpen && previousPrize && hasRevealed && !isSpinning) showResult(previousPrize);
    else if (isOpen && !previousPrize && !isSpinning) showExperience();
    else if (isOpen && previousPrize && !hasRevealed && !isSpinning) showExperience();
    scheduleTeaser({ immediate });
    if (previousPrize && hasRevealed) {
      dispatchGiftState(hasWon ? "won" : "reserved", previousPrize);
    }
    maybePromptForGift();
  };

  const restoreAwardedGift = async (cart = currentCart) => {
    const locallyEligible = eligibleSubtotal(cart) >= threshold;
    const hasRecoverableDraw = hasRevealed || Boolean(recoverableAward?.drawId && recoverableAward?.prize);
    if (previewMode || isSpinning || !hasRecoverableDraw || !locallyEligible) return false;
    if (giftRecoveryRequest) return giftRecoveryRequest;
    giftRecoveryRequest = (async () => {
      try {
        let latestCart = cart;

        // syncFromCart has already loaded the authoritative status. Only wait
        // once when a previous revocation is still being finalized; repeated
        // status polling can otherwise hold the cart for tens of seconds.
        if (checkoutValidationBlocked) {
          await wait(320);
          latestCart = await fetchCart();
          await loadProductionStatus(latestCart);
        }
        if (isBlocked) return false;

        // /gifts/reveal only reveals the reserved prize. Once the cart is
        // eligible again, /gifts/spin must securely reactivate that same draw
        // and return the grant used to add the free line.
        if (!secureAward && currentDrawId && hasRevealed && !checkoutValidationBlocked && !isBlocked) {
          try {
            await requestSecureActivation(latestCart);
          } catch (_error) {
            // The previously validated award remains usable only for this same
            // cart and draw; Shopify will still verify that it becomes free.
          }
        }

        const cartIdentity = cartToken(latestCart);
        const recoveryAward = secureAward || recoverableAward;
        const sameCart = Boolean(recoveryAward?.cartToken) && recoveryAward.cartToken === cartIdentity;
        const sameDraw = !currentDrawId || !recoveryAward?.drawId || recoveryAward.drawId === currentDrawId;
        const stillEligible = eligibleSubtotal(latestCart) >= threshold;
        if (!recoveryAward || !sameCart || !sameDraw || !stillEligible || checkoutValidationBlocked || isBlocked) return false;
        if (recoveryAward.isVoucher) {
          currentCart = latestCart;
          secureAward = recoveryAward;
          hasWon = true;
          return true;
        }
        if (cartHasAwardedGift(latestCart, recoveryAward)) {
          currentCart = latestCart;
          secureAward = recoveryAward;
          hasWon = true;
          return true;
        }

        currentCart = await addGrantedGift(recoveryAward);
        secureAward = recoveryAward;
        recoverableAward = recoveryAward;
        hasWon = true;
        // A result dismissed while it was still locked may surface once more
        // when the same coupon becomes free, so the customer sees the success
        // state instead of wondering whether the automatic add worked.
        isDismissed = false;
        await refreshCartInterface();
        syncTeaserContent();
        syncProgress();
        if (isOpen && previousPrize) showResult(previousPrize);
        dispatchGiftState("won", previousPrize || recoveryAward.prize);
        return true;
      } catch (error) {
        console.error("[Blankabric Gift] Restauration du gain impossible", JSON.stringify({
          code: error?.debugCode || error?.message || "unknown",
          status: Number(error?.httpStatus || 0),
        }));
        if (isOpen) showError(error.userMessage || labels.error || "");
        return false;
      }
    })();
    try { return await giftRecoveryRequest; } finally { giftRecoveryRequest = null; }
  };

  const setSpinning = (spinning) => {
    isSpinning = spinning;
    component.classList.toggle("is-spinning", spinning);
    stage?.setAttribute("aria-busy", String(spinning));
    if (spinButton) spinButton.disabled = spinning || isBlocked || (hasPlayed && hasRevealed);
    syncBrowseControls();
    if (spinning) announce(labels.spinning || "");
  };

  const spin = async () => {
    const revealingExistingDraw = Boolean(hasPlayed && previousPrize && !hasRevealed);
    if (isSpinning || !currentCart || isBlocked || (hasPlayed && !revealingExistingDraw) || !prizes.length) return;
    setSpinning(true);
    showError("");
    if (confirmation) confirmation.hidden = true;

    // L'animation part dans la même frame que le clic. Le serveur choisit le
    // coupon en parallèle : aucun écran ou libellé de chargement ne précède le jeu.
    const reelMotion = startMysteryMotion();
    const motionFloor = new Promise((resolve) => window.setTimeout(resolve, reducedMotion.matches ? 50 : 700));

    try {
      const awardPromise = previewMode
        ? Promise.resolve({ prize: selectPreviewPrize(), drawId: "preview" })
        : revealingExistingDraw
          ? Promise.resolve({ prize: previousPrize, drawId: currentDrawId })
          : stabilizeCartIdentity(currentCart).then((cart) => requestSecureReveal(cart));
      const [award] = await Promise.all([awardPromise, motionFloor]);
      if (!award?.prize) throw new Error("gift_prize_missing");
      void resolvePrizeImage(award.prize);
      await animateToPrize(award.prize, reelMotion);
      // Leave the winning card under the fixed pointer long enough to read it.
      await wait(reducedMotion.matches ? 0 : 650);

      hasPlayed = true;
      previousPrize = award.prize;
      currentDrawId = award.drawId || currentDrawId;
      hasRevealed = true;
      isDismissed = false;
      storeRevealMarker(currentDrawId);
      if (previewMode) {
        storePreviewPrize(currentCart, previousPrize);
        hasWon = isEligible;
      }

      if (!previewMode && secureAward && isEligible && !secureAward.isVoucher) {
        currentCart = await addGrantedGift(secureAward);
        await refreshCartInterface();
        hasWon = true;
      }

      setSpinning(false);
      syncTeaserContent();
      syncProgress();
      launchConfetti();
      showResult(previousPrize, { focus: true });
      if (hasWon && !previewMode && !previousPrize?.isVoucher) {
        if (confirmation) confirmation.hidden = false;
      }
    } catch (error) {
      console.error("[Blankabric Gift] Tirage impossible", {
        code: error?.debugCode || error?.message || "unknown",
        status: Number(error?.httpStatus || 0),
      });
      stopAnimations();
      setSpinning(false);
      showExperience({ rebuild: true });
      showError(error.userMessage || labels.error || "");
    }
  };

  const resetPreview = () => {
    if (!previewMode || isSpinning) return;
    clearPreviewPrize(currentCart);
    previousPrize = null;
    hasPlayed = false;
    hasRevealed = false;
    isDismissed = false;
    hasWon = false;
    showError("");
    showExperience({ rebuild: true });
    syncTeaserContent();
  };

  const navigateToSecureCheckout = async (validatedCart = currentCart) => {
    if (isNavigating) return;
    isNavigating = true;
    try {
      if (secureAward && !secureAward.isVoucher && !cartHasGrant(validatedCart, secureAward.grant)) currentCart = await addGrantedGift(secureAward);
      window.location.assign(secureAward?.checkoutUrl || pendingCheckoutUrl || defaultCheckoutUrl);
    } catch (error) {
      isNavigating = false;
      openSheet({ attention: true });
      showError(error.userMessage || labels.checkoutValidationError || labels.error || "");
    }
  };

  const continueToCheckoutSafely = async (cart, destinationUrl = defaultCheckoutUrl) => {
    let latestCart = cart;
    const giftLines = (latestCart?.items || []).filter(hasGiftProperty);
    const hasOneValidFreeGift = giftLines.length === 1 &&
      Number(giftLines[0].quantity) === 1 &&
      Number(giftLines[0].final_line_price) === 0;
    if (giftLines.length && !hasOneValidFreeGift) {
      latestCart = await removeInvalidGiftLines(latestCart);
      await refreshCartInterface();
    }
    currentCart = latestCart;
    isNavigating = true;
    window.location.assign(destinationUrl || defaultCheckoutUrl);
  };

  const openBeforeCheckout = async (checkoutUrl = defaultCheckoutUrl) => {
    pendingCheckoutUrl = checkoutUrl || defaultCheckoutUrl;
    let cart;
    try {
      cart = await fetchCart();
    } catch (_error) {
      return Boolean(secureAward);
    }
    if (secureAward?.cartToken && secureAward.cartToken !== cartToken(cart)) secureAward = null;
    if (recoverableAward?.cartToken && recoverableAward.cartToken !== cartToken(cart)) recoverableAward = null;
    const hadGiftContext = Boolean(secureAward || previousPrize || (cart.items || []).some(hasGiftProperty));
    const locallyEligible = eligibleSubtotal(cart) >= threshold;

    if (previewMode) {
      renderState({ immediate: true });
      if (!locallyEligible || !prizes.length) return false;
      if (hasPlayed) return false;
      openSheet({ attention: true });
      return true;
    }

    const configReady = hadGiftContext ? true : await loadProductionConfig(cart, { force: true });
    const statusReady = await loadProductionStatus(cart);
    if (((!configReady && !productionConfigLoaded) || !statusReady) && (locallyEligible || hadGiftContext)) {
      await continueToCheckoutSafely(cart, pendingCheckoutUrl);
      return true;
    }
    if (!configReady && productionConfigLoaded && !productionConfigEnabled) return false;
    if (checkoutValidationBlocked) {
      await continueToCheckoutSafely(cart, pendingCheckoutUrl);
      return true;
    }
    if (statusReady && giftCleanupNeeded) {
      try {
        cart = await removeInvalidGiftLines(cart);
        await refreshCartInterface();
      } catch (_error) {
        await continueToCheckoutSafely(cart, pendingCheckoutUrl);
        return true;
      }
    }
    if (!statusReady || isBlocked) return false;
    if (hasPlayed && hasRevealed && locallyEligible) {
      const restored = await restoreAwardedGift(cart);
      const validatedCart = currentCart || cart;
      if (restored && (secureAward?.isVoucher || cartHasAwardedGift(validatedCart))) {
        await navigateToSecureCheckout(validatedCart);
        return true;
      }
      await continueToCheckoutSafely(validatedCart, pendingCheckoutUrl);
      return true;
    }
    if (hasWon && secureAward) {
      await navigateToSecureCheckout(cart);
      return true;
    }
    if (!isEligible || !prizes.length) return false;
    if (hasPlayed && !secureAward) {
      await continueToCheckoutSafely(cart, pendingCheckoutUrl);
      return true;
    }
    openSheet({ attention: true });
    announce(labels.unlocked || "");
    return true;
  };

  const requestCheckout = async (destinationUrl = defaultCheckoutUrl) => {
    if (checkoutRequestInFlight || isNavigating) return;
    checkoutRequestInFlight = true;
    try {
      const opened = await openBeforeCheckout(destinationUrl);
      if (!opened) {
        isNavigating = true;
        window.location.assign(destinationUrl);
      }
    } catch (_error) {
      try {
        await continueToCheckoutSafely(await fetchCart(), destinationUrl);
      } catch (_fallbackError) {
        isNavigating = true;
        window.location.assign(destinationUrl);
      }
    } finally {
      if (!isNavigating) checkoutRequestInFlight = false;
    }
  };

  const syncFromCart = async (cart, { immediate = false } = {}) => {
    currentCart = cart;
    drawStatusKnown = previewMode;
    if (previewMode) {
      isBlocked = false;
      isEligible = !isBlocked && eligibleSubtotal(cart) >= threshold;
      previousPrize = readPreviewPrize(cart);
      hasPlayed = Boolean(previousPrize);
      hasRevealed = hasPlayed;
      hasWon = hasPlayed && isEligible;
      renderState({ immediate });
      return;
    }
    await loadProductionConfig(cart);
    if (!hasPrivateCartToken(cart) && !(cart.items || []).length) {
      drawStatusKnown = true;
      isBlocked = !configCurrencyMatches();
      isEligible = false;
      hasPlayed = false;
      hasRevealed = false;
      hasWon = false;
      previousPrize = null;
      secureAward = null;
      recoverableAward = null;
      currentDrawId = "";
      pendingCheckoutUrl = defaultCheckoutUrl;
      giftCleanupNeeded = false;
      renderState({ immediate });
      return;
    }
    if (!hasPrivateCartToken(cart)) {
      cart = await stabilizeCartIdentity(cart);
      currentCart = cart;
    }
    const statusReady = await loadProductionStatus(cart);
    if (statusReady && giftCleanupNeeded && !checkoutValidationBlocked) {
      await removeInvalidGiftLines(cart);
      await refreshCartInterface();
    }
    const locallyEligible = eligibleSubtotal(currentCart) >= threshold;
    if ((hasRevealed || recoverableAward) && locallyEligible) {
      await restoreAwardedGift(currentCart);
    }
    renderState({ immediate });
  };

  const queueCartSync = (cart, { immediate = false } = {}) => {
    if (!cart || !Array.isArray(cart.items)) return Promise.resolve();
    queuedCartSync = cart;
    queuedCartSyncImmediate = queuedCartSyncImmediate || immediate;
    if (cartSyncRequest) return cartSyncRequest;

    cartSyncRequest = (async () => {
      while (queuedCartSync) {
        const nextCart = queuedCartSync;
        const nextImmediate = queuedCartSyncImmediate;
        queuedCartSync = null;
        queuedCartSyncImmediate = false;
        await syncFromCart(nextCart, { immediate: nextImmediate });
      }
    })().finally(() => {
      cartSyncRequest = null;
      if (queuedCartSync) queueCartSync(queuedCartSync, { immediate: queuedCartSyncImmediate }).catch(() => {});
    });

    return cartSyncRequest;
  };

  teaser?.addEventListener("click", () => {
    if (teaserDock && !component.classList.contains("is-teaser-expanded")) {
      revealTeaser();
      return;
    }
    openSheet();
  });
  teaserDismissButton?.addEventListener("click", dismissTeaser);
  teaserDock?.addEventListener("pointerenter", (event) => {
    if (event.pointerType !== "mouse") return;
    teaserHovered = true;
    revealTeaser();
  });
  teaserDock?.addEventListener("pointerleave", (event) => {
    if (event.pointerType !== "mouse") return;
    teaserHovered = false;
    scheduleTeaserCollapse();
  });
  teaserDock?.addEventListener("focusin", (event) => {
    if (!(event.target instanceof Element) || !event.target.matches(":focus-visible")) return;
    teaserKeyboardFocused = true;
    revealTeaser();
  });
  teaserDock?.addEventListener("focusout", (event) => {
    if (teaserDock.contains(event.relatedTarget)) return;
    teaserKeyboardFocused = false;
    scheduleTeaserCollapse();
  });
  document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-bb-gift-open]') : null;
    if (!button || giftPromptOpening) return;
    event.preventDefault();
    giftPromptOpening = true;
    button.setAttribute('aria-busy', 'true');
    try {
      await queueCartSync(await fetchCart(), { immediate: true });
      openSheet({ attention: true });
      if (!drawStatusKnown || !productionConfigEnabled) {
        const text = button.closest('[data-bb-gift-prompt]')?.querySelector('[data-bb-gift-prompt-text]');
        if (text) text.textContent = labels.configurationError || labels.error || '';
      }
    } catch (_error) {
      const text = button.closest('[data-bb-gift-prompt]')?.querySelector('[data-bb-gift-prompt-text]');
      if (text) text.textContent = labels.error || '';
    } finally {
      giftPromptOpening = false;
      button.removeAttribute('aria-busy');
    }
  });
  closeButton?.addEventListener("click", () => {
    const showCart = Boolean(hasRevealed && cartHasAwardedGift());
    dismissCurrentDraw();
    closeSheet({ showCart });
  });
  backdrop?.addEventListener("click", () => closeSheet());
  spinButton?.addEventListener("click", spin);
  resetButton?.addEventListener("click", resetPreview);
  previousPrizeButton?.addEventListener("click", () => browsePrizes(-1));
  nextPrizeButton?.addEventListener("click", () => browsePrizes(1));

  let reelSwipeStart = null;
  let suppressProductClickUntil = 0;
  reelWindow?.addEventListener("pointerdown", (event) => {
    if (!currentPlan?.browsable || isSpinning) return;
    reelSwipeStart = { x: event.clientX, y: event.clientY };
  });
  reelWindow?.addEventListener("pointermove", (event) => {
    if (!reelSwipeStart) return;
    const deltaX = event.clientX - reelSwipeStart.x;
    const deltaY = event.clientY - reelSwipeStart.y;
    if (Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY)) {
      suppressProductClickUntil = Date.now() + 350;
    }
  });
  reelWindow?.addEventListener("pointerup", () => {
    reelSwipeStart = null;
  });
  reelWindow?.addEventListener("pointercancel", () => { reelSwipeStart = null; });
  reelTrack?.addEventListener("click", (event) => {
    const card = event.target instanceof Element ? event.target.closest("[data-bb-reel-product]") : null;
    if (!(card instanceof HTMLElement) || !currentPlan?.browsable || isSpinning) return;
    if (Date.now() < suppressProductClickUntil) {
      event.preventDefault();
      return;
    }
    openPrizeProduct({
      handle: card.dataset.productHandle || "",
      url: card.dataset.productUrl || "",
      title: card.dataset.productTitle || "",
    });
  });

  let teaserPointerY = null;
  teaser?.addEventListener("pointerdown", (event) => { teaserPointerY = event.clientY; });
  teaser?.addEventListener("pointerup", (event) => {
    if (teaserPointerY !== null && teaserPointerY - event.clientY > 28) openSheet();
    teaserPointerY = null;
  });
  teaser?.addEventListener("pointercancel", () => { teaserPointerY = null; });

  let sheetDragStart = null;
  let sheetDragY = 0;
  sheetHandle?.addEventListener("pointerdown", (event) => {
    if (isSpinning) return;
    sheetDragStart = event.clientY;
    sheetDragY = 0;
    sheetHandle.setPointerCapture?.(event.pointerId);
    component.classList.add("is-dragging");
  });
  sheetHandle?.addEventListener("pointermove", (event) => {
    if (sheetDragStart === null || !sheet) return;
    sheetDragY = Math.max(0, event.clientY - sheetDragStart);
    const dragX = window.matchMedia("(max-width: 640px)").matches ? "0" : "50%";
    sheet.style.transform = `translate3d(${dragX},${sheetDragY}px,0)`;
    backdrop.style.opacity = String(Math.max(0, 1 - sheetDragY / 360));
  });
  const finishSheetDrag = () => {
    if (sheetDragStart === null) return;
    component.classList.remove("is-dragging");
    const shouldClose = sheetDragY > 72;
    sheetDragStart = null;
    sheetDragY = 0;
    sheet.style.removeProperty("transform");
    backdrop.style.removeProperty("opacity");
    if (shouldClose) closeSheet();
  };
  sheetHandle?.addEventListener("pointerup", finishSheetDrag);
  sheetHandle?.addEventListener("pointercancel", finishSheetDrag);

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && isOpen) closeSheet();
  });

  document.addEventListener("blankabric:cart-updated", (event) => {
    const cart = event.detail?.cart;
    if (!cart || !Array.isArray(cart.items) || isSpinning || checkoutRequestInFlight || isNavigating) return;
    queueCartSync(cart, { immediate: true }).catch(() => {});
  });

  document.addEventListener("click", (event) => {
    if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = event.target instanceof Element ? event.target.closest("[data-bb-gift-checkout], a[href]") : null;
    if (!target || component.contains(target)) return;
    const explicit = target.matches("[data-bb-gift-checkout]");
    const rawDestination = target.getAttribute("href") || defaultCheckoutUrl;
    let destination;
    try { destination = new URL(rawDestination, window.location.origin); } catch (_error) { return; }
    if (!explicit && (destination.origin !== window.location.origin || !/\/checkout\/?$/.test(destination.pathname))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    requestCheckout(destination.toString());
  }, true);

  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || component.contains(form)) return;
    const control = event.submitter instanceof HTMLElement ? event.submitter : document.activeElement;
    const checkout = control?.matches?.('[data-bb-gift-checkout], [name="checkout"], #checkout') || form.id === "cart-form";
    if (!checkout) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    requestCheckout(defaultCheckoutUrl);
  }, true);

  window.addEventListener("resize", () => {
    if (isSpinning || !currentPlan) return;
    if (currentPlan.browsable) return;
    window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(() => setTrackPosition(currentPlan, currentPlan.currentIndex));
  });

  window.BlankabricGiftRoulette = { openBeforeCheckout, open: openSheet };

  const initialize = async () => {
    try {
      const cart = await fetchCart();
      await queueCartSync(cart);
      if (prizes.length) buildMachine();
      if (params.get("bb_roulette_open") === "1") {
        teaserReady = true;
        openSheet({ focus: false });
      }
    } catch (error) {
      console.error("[Blankabric Gift] Initialisation impossible", {
        code: error?.debugCode || error?.message || "unknown",
        status: Number(error?.httpStatus || 0),
      });
      productionConfigEnabled = false;
      component.hidden = true;
    }
  };

  const scheduleInitialization = () => {
    const run = () => initialize();
    run();
  };

  if (document.readyState === "complete") scheduleInitialization();
  else window.addEventListener("load", scheduleInitialization, { once: true });
})();
